import { Angulartics2 } from '@angularticsCompat';
import { BehaviorSubject } from 'rxjs';
import { TRACKER_UPDATE_COLOR_MODE } from '../constants/constants';
import { ColorMode } from '../interfaces/color-mode';
import { LocalStorageService } from './local-storage.service';


export class ColorModeService {
  static deps = [
    LocalStorageService,
    Angulartics2
  ];

  private _colorMode$ = new BehaviorSubject<ColorMode>(ColorMode.LIGHT);

  colorMode$ = this._colorMode$.asObservable();

  constructor(
    private _localStorageService: LocalStorageService,
    protected _angulartics: Angulartics2
  ) {
    this._colorMode$.next(this._getColorMode());
  }

  toggleColorMode() {
    const mode = this._colorMode$.getValue();
    let newMode;

    if (mode === ColorMode.DARK) {
      newMode = ColorMode.LIGHT;
    } else {
      newMode = ColorMode.DARK;
    }

    this.setColorMode(newMode);
  }

  setColorMode(mode: ColorMode = ColorMode.LIGHT) {
    document.body.classList.remove(`color-mode-${ this._colorMode$.getValue() }`);

    setTimeout(() => {
      this._colorMode$.next(mode);
      this._localStorageService.set('colorMode', mode);
      document.body.classList.add(`color-mode-${ mode }`);

    }, 0);

    this._angulartics.eventTrack.next({
      action: TRACKER_UPDATE_COLOR_MODE,
      properties: {
        colorMode: mode
      }
    });
  }

  private _getColorMode(): ColorMode {
    return this._localStorageService.get('colorMode') as ColorMode;
  }

  getColorModeValue() {
    return this._colorMode$.getValue();
  }
}
